module.exports = __webpack_public_path__ + "img/1714.96ade8ce.gif";